import Fuse from 'fuse.js';

const PAGE = {
  TABS_HIDDEN_CLASS: 'faq__top-buttons--hidden',
  TAB_ACTIVE: 'faq__top-button--active',
  QUESTION_BLOCK_CLASS: 'question__block',
  QUESTION_BLOCK_TEXT_CLASS: 'question__block-text',
  INPUT: document.querySelector('e'),
  TABS: document.querySelectorAll('e'),
  TABS_BUTTONS: document.querySelector('e'),
  QUESTIONS: document.querySelectorAll('e')
};

const toggleQuestion = (event) => {
  let question = event.target.closest('.question');

  question.classList.toggle('question--hidden');
  $(question.querySelector('.question__answer')).slideToggle('slow');
};

const handleQuestionClick = () => {
  const buttons = document.getElementsByClassName(PAGE.QUESTION_BLOCK_CLASS);

  Array.from(buttons).forEach((button) =>
    button.addEventListener('click', (event) => toggleQuestion(event))
  );
};

const handleTabsUpdate = (buttonIndex) => {
  const hiddenTabClass = 'faq__questions-list--hidden';

  Array.from(document.getElementsByClassName('faq__top-button')).forEach((button, index) => {
    if (index === buttonIndex) {
      button.classList.add(PAGE.TAB_ACTIVE);
    } else {
      button.classList.remove(PAGE.TAB_ACTIVE);
    }
  });

  Array.from(PAGE.TABS).forEach((tabList, tabIndex) => {
    if (buttonIndex === tabIndex) {
      tabList.classList.remove(hiddenTabClass);
    } else {
      tabList.classList.add(hiddenTabClass);
    }
  });
};

const handleTabsClick = () =>
  Array.from(document.getElementsByClassName('faq__top-button')).forEach((button, index) => {
    button.addEventListener('click', () => handleTabsUpdate(index));
  });

const toggleTabsButtonsView = (show = false) =>
  show
    ? PAGE.TABS_BUTTONS.classList.remove(PAGE.TABS_HIDDEN_CLASS)
    : PAGE.TABS_BUTTONS.classList.add(PAGE.TABS_HIDDEN_CLASS);

const findQuestionByText = (text) =>
  Array.from(PAGE.QUESTIONS)
    .filter(
      (question) =>
        question.querySelector(`.${PAGE.QUESTION_BLOCK_TEXT_CLASS}`).textContent.trim() == text
    )[0]
    .cloneNode(true);

const generateSearchResult = (searchValue = '') => {
  const lastTab = PAGE.TABS[PAGE.TABS.length - 1];

  lastTab.replaceChildren();

  new Fuse(
    Array.from(PAGE.QUESTIONS).map((question) =>
      question.querySelector(`.${PAGE.QUESTION_BLOCK_TEXT_CLASS}`).textContent.trim()
    ),
    {threshold: 0.25, ignoreLocation: true}
  )
    .search(searchValue)
    .forEach((questionText) => {
      let newQuestionItem = findQuestionByText(questionText.item);

      newQuestionItem
        .querySelector(`.${PAGE.QUESTION_BLOCK_CLASS}`)
        .addEventListener('click', (event) => toggleQuestion(event));

      lastTab.appendChild(newQuestionItem);
    });
};

const openLastTab = () => handleTabsUpdate(PAGE.TABS.length - 1);

const handleSearchUpdate = () => {
  if (PAGE.INPUT.value !== '') {
    toggleTabsButtonsView();
    generateSearchResult(PAGE.INPUT.value);
    openLastTab();
  }
};

const handleSearchInput = () =>
  PAGE.INPUT?.addEventListener('keyup', (event) => {
    if (event.target.value === '') {
      toggleTabsButtonsView(true);
      handleTabsUpdate(0);
    } else {
      handleSearchUpdate();
    }
  });

const FaqComponent = () => {
  PAGE.INPUT = document.querySelector('#search-input');
  PAGE.TABS_BUTTONS = document.querySelector('.faq__top-buttons');
  PAGE.TABS = document.querySelectorAll('.faq__questions-list');
  PAGE.QUESTIONS = document.querySelectorAll('.question');

  handleQuestionClick();
  handleTabsClick();
  handleSearchInput();
};

export const Faq = () => {
  $(document).ready(() => FaqComponent());
};
